import useIsMobile from '@/hooks/useIsMobile';

export const Loading = () => {
  const { isMobile } = useIsMobile();

  return (
    <>
      <div className="h-[200px] w-full animate-pulse  rounded-2xl bg-gray-300 py-8"></div>
      {!isMobile && <div className="h-[200px] w-full animate-pulse  rounded-2xl bg-gray-300 py-8"></div>}
      {!isMobile && <div className="h-[200px] w-full animate-pulse  rounded-2xl bg-gray-300 py-8"></div>}
    </>
  );
};
